import React, { useEffect, useState } from 'react';
import DesiredVehNotAvailImg from 'src/content/images/Desired_VehNotAvail.jpg';
import { ElementCompact, xml2js } from 'xml-js';
import { strings } from 'src/localization';
import css from './VehicleImages.module.scss';
import axios from 'axios';
const soapRequest = require('easy-soap-request');
interface IProps {
    year: string;
    make: string;
    model: string;
    type: 'full' | 'thumb' | 'display';
    className?: string;
    Itype?: string;
}

const VehicleModelImages = (props: IProps) => {
    const [imgUrl, setImgUrl] = useState('');
    const [imgAlt, setImgAlt] = useState('');
    useEffect(() => {
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        // Remove TRUCK from the make if it exists.  The system is using true make names but VIN decode can
        // return sub makes like TOYOTA TRUCK and not just TOYOTA
        // let callMakeStr = props.make.replace('TRUCK', '');
        // Remove SAV from the BMW SAV make.  I did not want to use the replace feature here since this can
        // remove the string SAV from within a string and therefore may catch more than I want.
        // Unlike the TRUCK case above, I dont know any other makes using SAV as a sub make
        // if (callMakeStr === 'BMW SAV') {
        //     callMakeStr = 'BMW';
        // }
        let callMakeStr = props.make.toUpperCase();
        const makeArray = props.make ? callMakeStr.split(' ') : '';
        // If the second or third word in the make is truck or van, the default is to return the first word,
        // since it is likely the base make.
        const needBaseMake = makeArray[1] === 'TRUCK' || makeArray[1] === 'VAN' || makeArray[1] === 'SAV' ||
                         makeArray[2] === 'VAN' || makeArray[2] === 'TRUCK' || props.make === 'BMW MOTORCYCLES' ||
                         props.make === 'HONDA MOTORCYCLE' || props.make === 'SUZUKI MOTORCYCLE';
        // The list of makes in the exception below do not appear to contain base makes. As a result, the make
        // is currently being sent as is to the api.
        const baseMakeException = props.make === 'CLARK INDUSTRIAL TRUCK' || props.make === 'MACK TRUCK' ||
                         props.make === 'NAVISTAR INTL TRUCK' || props.make === 'OSHKOSH TRUCK' ||
                         props.make === 'UMC TRUCK';
        if (needBaseMake && !baseMakeException) {
            // If we meet the needBaseMake condition and the make is not in the exception condition, by default
            // set the make to the first word in the make.
            callMakeStr = makeArray[0];
            // A list of special cases is listed below.
            if (callMakeStr === 'MERCEDES') {
                callMakeStr = 'MERCEDES-BENZ';
            }
            if (props.make.toUpperCase() === 'WHITE GMC TRUCK') {
                callMakeStr = 'GMC';
            }
        }
        if (props.make.toUpperCase() === 'GENERAL MOTORS') {
            callMakeStr = 'GMC';
        }
        if (props.make.toUpperCase() === 'FORD CANADA') {
            callMakeStr = 'Ford';
        }
        if (props.make.toUpperCase() === 'CHRYSLER CANADA') {
            callMakeStr = 'Chrysler';
        }
        if (props.make.toUpperCase() === 'VW CANADA') {
            callMakeStr = 'Volkswagen';
        }

        async function fetchImage() {
            const userName = 'DMS Application User';
            const pwd = '$Integration';
            // Test when not on SB13;
            const sysId = 'ERA01SB13000000';
            const sysNum = window.location.href.slice(10, 16);
            let MCsysNum = sysNum;
            if (MCsysNum === 'alhost') {
                MCsysNum = '080026';
            }
            const storeNum = '01';
            const branchNum = '01';
            const sysType = 'ERA';
            const appCode = 'SVC';
            const type = window.location.href.slice(8, 10).toUpperCase();
            let url = 'https://ddwhub.reyrey.net/services/IntegrationService.asmx';

            if (type === 'RD' || type === 'RI') {
                url = 'https://receiver.ddwqa01.reyqa.com/services/IntegrationService.asmx';
            }
            // For 199199 we should point to production and not QA.
            if (sysNum === '199199') {
                url = 'https://ddwhub.reyrey.net/services/IntegrationService.asmx';
            }

            if (props?.Itype) {
                if (props.Itype === '1') {
                    url = 'https://ddwhub.reyrey.net/services/IntegrationService.asmx';
                }
                if (props.Itype === '2') {
                    url = 'https://receiver.ddwqa01.reyqa.com/services/IntegrationService.asmx';
                }
                if (props.Itype === '3') {
                    url = 'https://receiver.ddwqa02.reyqa.com/services/IntegrationService.asmx';
                }
                if (props.Itype === '4') {
                    url = 'https://receiver-sb01.reyqa.com/services/IntegrationService.asmx';
                }
                if (props.Itype === '5') {
                    url = 'https://receiver-sb02.reyqa.com/services/IntegrationService.asmx';
                }
            }

            if (sysNum === 'alhost') {
                url = '/services-ddwhub/IntegrationService.asmx';
            }

            const xml = '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' +
                'xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
                '<soap:Body>' +
                '<VehicleGetProfilePhoto xmlns="http://reyrey.com/">' +
                '<VehicleCredentials>' +
                '<Username>' + userName + '</Username>' +
                '<Password>' + pwd + '</Password>' +
                '<SysType>' + sysType + '</SysType>' +
                '<SysID>' + sysId + '</SysID>' +
                '<StoreNo>' + storeNum + '</StoreNo>' +
                '<BranchNo>' + branchNum + '</BranchNo>' +
                '<DMSSysNum>' + MCsysNum + '</DMSSysNum>' +
                '<AppCode>' + appCode + '</AppCode>' +
                '</VehicleCredentials>' +
                '<VehicleGetProfilePhotoRequest>' +
                '<Make>' + callMakeStr + '</Make>' +
                '<Model>' + props.model + '</Model>' +
                '<Year>' + props.year + '</Year>' +
                '</VehicleGetProfilePhotoRequest>' +
                '</VehicleGetProfilePhoto>' +
                '</soap:Body>' +
                '</soap:Envelope>';
            setImgUrl(DesiredVehNotAvailImg);
            setImgAlt('');
            const header = {
                'content-type': 'text/xml; charset=utf-8',
                'SOAPAction': 'http://reyrey.com/VehicleGetProfilePhoto',
                'Access-Control-Allow-Origin': sysNum === 'lhost' ? '*' : window.location.origin,
            };
            try {
                if (props.year) {
                    const { response } = await soapRequest({ url: url, headers: header, xml: xml });
                    const { body, statusCode } = response;
                    let imageUrl = '';
                    if (statusCode === 200) {
                        const rtn = xml2js(body, { compact: true, textKey: 'text' }) as ElementCompact;
                        const soapBody = rtn['soap:Envelope']['soap:Body'];
                        const result = soapBody.VehicleGetProfilePhotoResponse.VehicleGetProfilePhotoResult.VehicleStockPhoto;
                        imageUrl = result.Url?.text !== undefined && result.Url?.text !== '' ? result.Url?.text : '';
                        if (imageUrl === '') {
                            setImgUrl(DesiredVehNotAvailImg);
                            setImgAlt('');
                        } else if (props.type === 'thumb' || props.type === 'display') {
                            setImgUrl(imageUrl + '&tn=y');
                            setImgAlt(props.year + props.make + props.model + strings.Image);
                        } else {
                            setImgUrl(imageUrl);
                            setImgAlt(props.year + props.make + props.model + strings.Image);
                        }
                    } else {
                        imageUrl = '';
                        setImgUrl(DesiredVehNotAvailImg);
                        setImgAlt('');
                    }
                }
            } catch {
                setImgUrl(DesiredVehNotAvailImg);
                setImgAlt('');
            }
        }
        if (props.model !== '') {
            fetchImage();
        } else {
            setImgUrl(DesiredVehNotAvailImg);
            setImgAlt('');
        }

        return () => {
            source.cancel();
            setImgUrl('');
            setImgAlt('');
        };
    }, [props.model, props.year, props.make, props.type, props.Itype]);

    const imgClass = props.className ? props.className : (props.type !== 'thumb' ? css.vehicleModelImage : css.vehicleImage);

    return (
        <div id={'imageContainer_' + props.model}>
            <picture>
                <source srcSet={imgUrl}></source>
                <source srcSet={DesiredVehNotAvailImg}></source>
                <img
                    src={imgUrl}
                    alt={imgAlt}
                    className={imgClass}
                />
            </picture>
        </div>
    );
};

export default VehicleModelImages;